import React from 'react';
import PropTypes from 'prop-types';

// Utils
import youtubeUrlParser from '../../../utils/tools/youtubeUrlParser';

import styles from './YoutubePreview.module.scss';

const staticYoutubeBase = 'https://www.youtube.com/embed/';

function YoutubePreview({ url }) {
  return (
    url ? (
      <div className={styles.wrapper}>
        <iframe
          width="100%"
          height="100%"
          src={`${staticYoutubeBase}${youtubeUrlParser(url)}`}
          frameBorder="0"
          allowFullScreen
          title="Youtube preview for video URL"
        />
      </div>
    ) : null
  );
}

YoutubePreview.propTypes = {
  url: PropTypes.string.isRequired,
};

export default YoutubePreview;
